import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsSearch:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsSearchApiResponse,
        GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsSearchApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/eprescriptions/patients/search`,
          params: {
            firstname: queryArg.firstname,
            lastname: queryArg.lastname,
            dob: queryArg.dob,
            page: queryArg.page,
          },
        }),
      }),
    getV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientId:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiResponse,
        GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/eprescriptions/patients/${queryArg.dosespotPatientId}`,
        }),
      }),
    putV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientId:
      build.mutation<
        PutV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiResponse,
        PutV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/eprescriptions/patients/${queryArg.dosespotPatientId}`,
          method: "PUT",
        }),
      }),
    getV2ProviderEprescriptionsDeaNumbers: build.query<
      GetV2ProviderEprescriptionsDeaNumbersApiResponse,
      GetV2ProviderEprescriptionsDeaNumbersApiArg
    >({
      query: () => ({ url: `/v2/provider/eprescriptions/dea-numbers` }),
    }),
    postV2ProviderEprescriptionsDeaNumbers: build.mutation<
      PostV2ProviderEprescriptionsDeaNumbersApiResponse,
      PostV2ProviderEprescriptionsDeaNumbersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eprescriptions/dea-numbers`,
        method: "POST",
        body: queryArg.addDeaNumberRequest,
      }),
    }),
    deleteV2ProviderEprescriptionsDeaNumbersByDeaId: build.mutation<
      DeleteV2ProviderEprescriptionsDeaNumbersByDeaIdApiResponse,
      DeleteV2ProviderEprescriptionsDeaNumbersByDeaIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eprescriptions/dea-numbers/${queryArg.deaId}`,
        method: "DELETE",
      }),
    }),
    putV2ProviderEprescriptionsDeaNumbersByDeaId: build.mutation<
      PutV2ProviderEprescriptionsDeaNumbersByDeaIdApiResponse,
      PutV2ProviderEprescriptionsDeaNumbersByDeaIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eprescriptions/dea-numbers/${queryArg.deaId}`,
        method: "PUT",
        body: queryArg.updateDeaNumberRequest,
      }),
    }),
    getV2ProviderEprescriptionsRegistrationStatus: build.query<
      GetV2ProviderEprescriptionsRegistrationStatusApiResponse,
      GetV2ProviderEprescriptionsRegistrationStatusApiArg
    >({
      query: () => ({ url: `/v2/provider/eprescriptions/registration-status` }),
    }),
    postV2ProviderEprescriptionsSetupClinic: build.mutation<
      PostV2ProviderEprescriptionsSetupClinicApiResponse,
      PostV2ProviderEprescriptionsSetupClinicApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eprescriptions/setup-clinic`,
        method: "POST",
        body: queryArg.setupClinicRequest,
      }),
    }),
    postV2ProviderEprescriptionsSetupClinician: build.mutation<
      PostV2ProviderEprescriptionsSetupClinicianApiResponse,
      PostV2ProviderEprescriptionsSetupClinicianApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eprescriptions/setup-clinician`,
        method: "POST",
        body: queryArg.setupClinicianRequest,
      }),
    }),
    getV2ProviderEprescriptionsSso: build.query<
      GetV2ProviderEprescriptionsSsoApiResponse,
      GetV2ProviderEprescriptionsSsoApiArg
    >({
      query: () => ({ url: `/v2/provider/eprescriptions/sso` }),
    }),
    getV2ProviderEprescriptionsStatus: build.query<
      GetV2ProviderEprescriptionsStatusApiResponse,
      GetV2ProviderEprescriptionsStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/eprescriptions/status`,
        params: {
          patient_id: queryArg.patientId,
        },
      }),
    }),
    postV2ProviderPatientsByPatientIdEprescriptionsConnect: build.mutation<
      PostV2ProviderPatientsByPatientIdEprescriptionsConnectApiResponse,
      PostV2ProviderPatientsByPatientIdEprescriptionsConnectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eprescriptions/connect`,
        method: "POST",
        body: queryArg.connectPatientRequest,
      }),
    }),
    getV2ProviderPatientsByPatientIdEprescriptionsSso: build.query<
      GetV2ProviderPatientsByPatientIdEprescriptionsSsoApiResponse,
      GetV2ProviderPatientsByPatientIdEprescriptionsSsoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/eprescriptions/sso`,
      }),
    }),
    postV2ProviderPatientsByPatientIdMedicationHistoryConsent: build.mutation<
      PostV2ProviderPatientsByPatientIdMedicationHistoryConsentApiResponse,
      PostV2ProviderPatientsByPatientIdMedicationHistoryConsentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/medication-history/consent`,
        method: "POST",
      }),
    }),
    getV2ProviderPatientsByPatientIdMedicationsHistory: build.query<
      GetV2ProviderPatientsByPatientIdMedicationsHistoryApiResponse,
      GetV2ProviderPatientsByPatientIdMedicationsHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/medications/history`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsSearchApiResponse =
  /** status 200 OK */ DosespotPatientSearchResponse;
export type GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsSearchApiArg =
  {
    organizationId: string;
    firstname?: string | null;
    lastname?: string | null;
    dob?: string | null;
    page?: number;
  };
export type GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiResponse =
  /** status 200 OK */ DosespotPatientResponse;
export type GetV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiArg =
  {
    organizationId: string;
    dosespotPatientId: string;
  };
export type PutV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiResponse =
  /** status 200 OK */ DosespotPatientUpdateResponse;
export type PutV2AdminOrganizationsByOrganizationIdEprescriptionsPatientsAndDosespotPatientIdApiArg =
  {
    organizationId: string;
    dosespotPatientId: string;
  };
export type GetV2ProviderEprescriptionsDeaNumbersApiResponse =
  /** status 200 OK */ DeaNumberListResponse;
export type GetV2ProviderEprescriptionsDeaNumbersApiArg = void;
export type PostV2ProviderEprescriptionsDeaNumbersApiResponse =
  /** status 200 OK */ DeaNumberListResponse;
export type PostV2ProviderEprescriptionsDeaNumbersApiArg = {
  addDeaNumberRequest: AddDeaNumberRequest;
};
export type DeleteV2ProviderEprescriptionsDeaNumbersByDeaIdApiResponse =
  /** status 200 OK */ DeaNumberListResponse;
export type DeleteV2ProviderEprescriptionsDeaNumbersByDeaIdApiArg = {
  deaId: string;
};
export type PutV2ProviderEprescriptionsDeaNumbersByDeaIdApiResponse =
  /** status 200 OK */ DeaNumberListResponse;
export type PutV2ProviderEprescriptionsDeaNumbersByDeaIdApiArg = {
  deaId: string;
  updateDeaNumberRequest: UpdateDeaNumberRequest;
};
export type GetV2ProviderEprescriptionsRegistrationStatusApiResponse =
  /** status 200 OK */ RegistrationStatusResponse;
export type GetV2ProviderEprescriptionsRegistrationStatusApiArg = void;
export type PostV2ProviderEprescriptionsSetupClinicApiResponse =
  /** status 200 OK */ EprescriptionStatusResponse;
export type PostV2ProviderEprescriptionsSetupClinicApiArg = {
  setupClinicRequest: SetupClinicRequest;
};
export type PostV2ProviderEprescriptionsSetupClinicianApiResponse =
  /** status 200 OK */ EprescriptionStatusResponse;
export type PostV2ProviderEprescriptionsSetupClinicianApiArg = {
  setupClinicianRequest: SetupClinicianRequest;
};
export type GetV2ProviderEprescriptionsSsoApiResponse =
  /** status 200 OK */ ClinicianSsoResponse;
export type GetV2ProviderEprescriptionsSsoApiArg = void;
export type GetV2ProviderEprescriptionsStatusApiResponse =
  /** status 200 OK */ EprescriptionStatusResponse;
export type GetV2ProviderEprescriptionsStatusApiArg = {
  /** Optional patient ID to check patient connection status */
  patientId?: string | null;
};
export type PostV2ProviderPatientsByPatientIdEprescriptionsConnectApiResponse =
  /** status 200 OK */ PatientConnectionResponse;
export type PostV2ProviderPatientsByPatientIdEprescriptionsConnectApiArg = {
  patientId: string;
  connectPatientRequest: ConnectPatientRequest;
};
export type GetV2ProviderPatientsByPatientIdEprescriptionsSsoApiResponse =
  /** status 200 OK */ PatientSsoResponse;
export type GetV2ProviderPatientsByPatientIdEprescriptionsSsoApiArg = {
  patientId: string;
};
export type PostV2ProviderPatientsByPatientIdMedicationHistoryConsentApiResponse =
  /** status 200 OK */ RecordSurescriptsConsentResponse;
export type PostV2ProviderPatientsByPatientIdMedicationHistoryConsentApiArg = {
  patientId: string;
};
export type GetV2ProviderPatientsByPatientIdMedicationsHistoryApiResponse =
  /** status 200 OK */ MedicationHistoryListResponse;
export type GetV2ProviderPatientsByPatientIdMedicationsHistoryApiArg = {
  patientId: string;
};
export type DosespotPatientSearchResponse = {
  Items?: {
    [key: string]: any;
  }[];
  Result?: {
    [key: string]: string;
  };
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type DosespotPatientResponse = {
  Item?: {
    [key: string]: any;
  };
  Result?: {
    [key: string]: string;
  };
};
export type DosespotPatientUpdateResponse = {
  Id?: number;
  Result?: {
    [key: string]: string;
  };
};
export type DeaNumberItem = {
  /** Street address line 1 */
  address_line1?: string;
  /** Street address line 2 */
  address_line2?: string;
  /** City */
  city?: string;
  /** DoseSpot-assigned GUID for this DEA entry */
  dea_id: string;
  /** DEA registration number */
  dea_number: string;
  /** Two-letter state abbreviation */
  state?: string;
  /** ZIP code */
  zip_code?: string;
};
export type DeaNumberListResponse = {
  /** All DEA registrations for this clinician */
  dea_numbers: DeaNumberItem[];
};
export type AddDeaNumberRequest = {
  /** Street address line 1 */
  address_line1?: string | null;
  /** Street address line 2 */
  address_line2?: string | null;
  /** City */
  city?: string | null;
  /** DEA registration number */
  dea_number: string;
  /** Two-letter state abbreviation */
  state: string;
  /** ZIP code */
  zip_code?: string | null;
};
export type UpdateDeaNumberRequest = {
  /** Street address line 1 */
  address_line1?: string | null;
  /** Street address line 2 */
  address_line2?: string | null;
  /** City */
  city?: string | null;
  /** DEA registration number */
  dea_number: string;
  /** Two-letter state abbreviation */
  state: string;
  /** ZIP code */
  zip_code?: string | null;
};
export type RegistrationStatusResponse = {
  /** Whether the clinician has completed identity proofing */
  identity_proofing_complete: boolean;
  /** DoseSpot registration status (e.g. Pending, IDPSuccess, TFAActivatedSuccess) */
  registration_status: string;
};
export type EprescriptionStatusResponse = {
  /** Whether the organization has a DoseSpot clinic */
  organization_connected: boolean;
  /** Whether the patient is connected to DoseSpot (only present if patient_id provided) */
  patient_connected?: boolean | null;
  /** Whether the provider is registered as a DoseSpot clinician */
  user_connected: boolean;
};
export type DoseSpotClinic = {
  /** Street address */
  address_line1: string;
  /** City */
  city: string;
  /** Clinic name */
  clinic_name: string;
  /** Primary phone number. Accepts formats like 555-123-4567, (555) 123-4567, or 1-555-123-4567. Non-digit characters are stripped and US country code (1) is removed. Must be exactly 10 digits after normalization. */
  phone: string;
  /** State abbreviation (e.g., MA) */
  state: string;
  /** ZIP code */
  zip_code: string;
};
export type SetupClinicRequest = {
  /** Clinic data for organization setup */
  clinic: DoseSpotClinic;
};
export type DoseSpotClinician = {
  /** Street address */
  address: string;
  /** City */
  city: string;
  /** DEA Registration Number for prescribers (used for controlled substances). Format: two letters followed by seven digits (e.g., AB1234567). */
  dea_number?: string | null;
  /** Date of birth (YYYY-MM-DD) */
  dob: string;
  /** Email address */
  email: string;
  /** Set to true to indicate the clinician has requested EPCS (Electronic Prescribing for Controlled Substances). */
  epcs_requested?: boolean | null;
  /** Fax number. Accepts formats like 555-123-4567, (555) 123-4567, or 1-555-123-4567. Non-digit characters are stripped and US country code (1) is removed. Must be exactly 10 digits after normalization. */
  fax: string;
  /** First name */
  first_name: string;
  /** Last name */
  last_name: string;
  /** Individual NPI number */
  npi: string;
  /** Phone number. Accepts formats like 555-123-4567, (555) 123-4567, or 1-555-123-4567. Non-digit characters are stripped and US country code (1) is removed. Must be exactly 10 digits after normalization. */
  phone: string;
  /** State abbreviation (e.g., MA) */
  state: string;
  /** ZIP code */
  zip_code: string;
};
export type SetupClinicianRequest = {
  /** Clinician data for provider registration */
  clinician: DoseSpotClinician;
};
export type ClinicianSsoResponse = {
  /** URL to open DoseSpot clinician onboarding UI */
  sso_url: string;
};
export type PatientConnectionResponse = {
  /** Whether the patient is now connected to DoseSpot */
  connected: boolean;
  /** The patient ID */
  patient_id: string;
};
export type DoseSpotPatient = {
  /** Street address line 1. DoseSpot limits this to 35 characters. */
  address: string;
  /** Street address line 2 (apartment, suite, unit, etc.). */
  address_2?: string | null;
  /** City */
  city: string;
  /** Date of birth (YYYY-MM-DD) */
  dob: string;
  /** First name */
  first_name: string;
  /** Gender: 'male', 'female', or 'unknown'. Maps to DoseSpot values: Male=1, Female=2, Unknown=3. */
  gender: string;
  /** Patient height in inches. Required by DoseSpot for patients under 19. */
  height?: number | null;
  /** Last name */
  last_name: string;
  /** Phone number. Accepts formats like 555-123-4567, (555) 123-4567, or 1-555-123-4567. Non-digit characters are stripped and US country code (1) is removed. Must be exactly 10 digits after normalization. */
  phone: string;
  /** State abbreviation (e.g., MA) */
  state: string;
  /** Patient weight in pounds. Required by DoseSpot for patients under 19. */
  weight?: number | null;
  /** ZIP code */
  zip_code: string;
};
export type ConnectPatientRequest = {
  /** Patient data for DoseSpot connection */
  patient: DoseSpotPatient;
};
export type PatientSsoResponse = {
  /** URL to open DoseSpot prescribing UI for this patient */
  sso_url: string;
};
export type RecordSurescriptsConsentResponse = {
  consented?: boolean;
  /** Timestamp DoseSpot recorded the consent. */
  consented_at: string;
  /** ID of the background task that will pull the patient's history. Null if the task could not be enqueued. */
  pull_task_id?: string | null;
};
export type MedicationHistoryItem = {
  days_supply?: number | null;
  directions?: string | null;
  dose_form?: string | null;
  drug_name?: string | null;
  event_at: string;
  event_kind: string;
  lifecycle_kind: string;
  medication_event_id: string;
  medication_id: string;
  ndc?: string | null;
  payer_name?: string | null;
  quantity?: number | null;
  refills?: number | null;
  route?: string | null;
  rxcui?: string | null;
  strength?: string | null;
};
export type MedicationHistoryListResponse = {
  items?: MedicationHistoryItem[];
};
